import { mapGetters } from 'vuex'

export const authComputed = {
  ...mapGetters('user', ['loggedIn', 'userType', 'isEditor', 'isEmployee']),
}

export const clientGetters = {
  ...mapGetters('client', ['getCardsByStatus', 'getActivePackCards', 'getAvailableSlots']),
}

export const employeeCards = {
  ...mapGetters('cards', ['getCardsByUser', 'getUserCardsByStatus', 'getUnassignedCards']),
}

export const userTemplates = {
  ...mapGetters('templates', ['getTemplatesByUser']),
}

export const checklistsGetters = {
  ...mapGetters({
    getChecklist: 'checklists/getChecklist',
    getChecklistItem: 'checklists/getChecklistItem',
    getItemChecklist: 'checklists/getItemChecklist',
    isChecklistCompleted: 'checklists/isChecklistCompleted',
  }),
}
